import { useEffect, useReducer } from 'react'
import DraggableModal from '../../../../components/generic/DraggableModal'
import Button from '@mui/material/Button'
import Switch from '@mui/material/Switch'
import SelectBankAccountTag from '../../../../components/specific/customTags/selectBankAccountTag'
import EntitySelect from '../../../../components/specific/entity/EntitySelect'
import Grid from '@mui/material/Unstable_Grid2'
import TextField from '@mui/material/TextField'
import Typography from '@mui/material/Typography'
import theme from '../../../../helpers/theme'

const reducer = (state, action) => {
  switch (action.type) {
    default:
      return state
    case 'UPDATE_FIELD':
      return {
        ...state,
        ...action.payload,
      }
    case 'MODAL_TOGGLE':
      return {
        ...state,
        modalVisible: action.payload,
      }
  }
}

const CreateNewTransactionCounterparty = () => {
  const CPTY_TAG = 4
  const initialState = {
    name: '',
    description: '',
    isInternal: false,
    entity_id: undefined,
    tags: [],
    general_ledger_account_id: undefined,
    modalVisible: false,
  }
  const [state, dispatch] = useReducer(reducer, initialState)

  const textFieldProps = {
    size: 'small',
    variant: 'outlined',
    InputProps: {
      sx: {
        borderRadius: 0,
      },
    },
  }

  return (
    <>
      <Button
        onClick={() => {
          dispatch({
            type: 'MODAL_TOGGLE',
            payload: true,
          })
        }}
        disableElevation
        size='small'
        variant='contained'
        sx={{ fontSize: 14, textTransform: 'none', width: '15%' }}
      >
        + Add New
      </Button>
      {state.modalVisible && (
        <DraggableModal
          modalVisible={state.modalVisible}
          width='50%'
          handleCancelModal={() => {
            dispatch({
              type: 'MODAL_TOGGLE',
              payload: false,
            })
          }}
          modalTitle='Add new counterparty'
          content={
            <Grid
              container
              spacing={2}
              direction='column'
              columnSpacing={5}
              alignContent='center'
              sx={{ marginLeft: 10 }}
            >
              <Grid item container alignItems='center'>
                <Grid item xs={4}>
                  <Typography>Name</Typography>
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    {...textFieldProps}
                    onChange={(event) => {
                      dispatch({
                        type: 'UPDATE_FIELD',
                        payload: {
                          name: event.target.value,
                        },
                      })
                    }}
                  />
                </Grid>
              </Grid>
              <Grid item container alignItems='center'>
                <Grid item xs={4}>
                  <Typography>Description</Typography>
                </Grid>
                <Grid item xs={6}>
                  <TextField
                    {...textFieldProps}
                    onChange={(event) => {
                      dispatch({
                        type: 'UPDATE_FIELD',
                        payload: {
                          description: event.target.value,
                        },
                      })
                    }}
                  />
                </Grid>
              </Grid>
              <Grid item container alignItems='center'>
                <Grid item xs={4}>
                  <Typography>Is Internal</Typography>
                </Grid>
                <Grid item xs={6}>
                  <Switch
                    sx={{
                      '& .MuiSwitch-switchBase': {
                        color: theme.palette.secondary.light,
                      },
                      '& .Mui-checked': {
                        color: theme.palette.primary.main,
                      },
                    }}
                    checked={state.isInternal}
                    onChange={(event) => {
                      dispatch({
                        type: 'UPDATE_FIELD',
                        payload: {
                          isInternal: event.target.checked,
                          entity_id: undefined,
                        },
                      })
                    }}
                  />
                </Grid>
                <Grid item xs={12}>
                  <EntitySelect
                    autoLoad
                    onChange={(event) => {
                      dispatch({
                        type: 'UPDATE_FIELD',
                        payload: {
                          entity_id: event.target.value,
                        },
                      })
                    }}
                  />
                </Grid>
              </Grid>
            </Grid>
          }
        />
      )}
    </>
  )
}

export default CreateNewTransactionCounterparty
